import { useParams } from "react-router-dom"
import ArrowBackButton from "../../../components/button/ArrowBackButton"
import { useEffect, useState } from "react"
import useRatingQuota from "./useRatingQuota"
import { Select } from "antd"
import { Tooltip } from 'react-tooltip'
import ActionButtonGradient from "../../../components/button/ActionButtonGradient"

const RatingQuotaForm = () => {
    const [isUpdate, setIsUpdate] = useState(false)
    const params = useParams()
    const {
        payload,
        setProjectID,
        onChangeHandler,
        ratingChoices,
        businessUnits,
        getBusinessUnits,
        getRatingQuota,
        putRatingQuotaForm,
        postRatingQuotaForm,
        handleSelectBusinessUnit,
        handleSelectRemaining,
        handleSelectExcess,
        isSaving,
        getTotalQuota
    } = useRatingQuota()

    useEffect(() => {
        getBusinessUnits()
        if (params.project_id) {
            setProjectID(params.project_id)
            if (params.business_unit_id) {
                setIsUpdate(true)
                getRatingQuota(params.project_id, params.business_unit_id) 
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.project_id, params.business_unit_id])

    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{ marginBottom: '24px' }}>
                <ArrowBackButton title={isUpdate ? "Edit Rating Quota" : "Create Rating Quota"} isTwoSection={true}/>
            </div>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <h5 style={{ 
                    margin: 0,
                    marginBottom: '24px',
                    fontWeight: 600,
                    color: '#1a1a1a',
                    fontSize: '18px'
                }}>
                    Rating Quota Configuration
                </h5>

                <form onSubmit={
                    isUpdate?
                    (e) => putRatingQuotaForm(e):
                    (e) => postRatingQuotaForm(e)
                }>
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        border: '1px solid #e5e7eb',
                        marginBottom: '24px'
                    }}>
                        <div className="mb-4">
                            <label htmlFor="BusinessUnit" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Business Unit <span style={{color: 'red'}}>*</span>
                            </label>
                            <Select
                                allowClear
                                showSearch
                                size="large"
                                style={{
                                    width: '100%'
                                }}
                                name="BusinessUnit"
                                options={businessUnits}
                                placeholder="Enter Business Unit"
                                onChange={handleSelectBusinessUnit}
                                value={payload.BusinessUnitID}
                                fontSize="16px"
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                            />
                        </div>

                        <div className="row mb-4">
                            <div className="col-md-6">
                                <label htmlFor="APlusQuota" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    A+ Quota (%) <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max="100"
                                    name="APlusQuota"
                                    className="form-control" 
                                    id="APlusQuota" 
                                    placeholder="Enter A+ Quota" 
                                    value={payload.APlusQuota}
                                    onChange={onChangeHandler}
                                    onFocus={(e) => e.target.select()}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="AQuota" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    A Quota (%) <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max="100"
                                    name="AQuota"
                                    className="form-control" 
                                    id="AQuota" 
                                    placeholder="Enter A Quota" 
                                    value={payload.AQuota}
                                    onChange={onChangeHandler}
                                    onFocus={(e) => e.target.select()}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>
                        </div>

                        <div className="row mb-4">
                            <div className="col-md-6">
                                <label htmlFor="BPlusQuota" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    B+ Quota (%) <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max="100"
                                    name="BPlusQuota"
                                    className="form-control" 
                                    id="BPlusQuota" 
                                    placeholder="Enter B+ Quota" 
                                    value={payload.BPlusQuota}
                                    onChange={onChangeHandler}
                                    onFocus={(e) => e.target.select()}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="BQuota" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    B Quota (%) <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max="100"
                                    name="BQuota"
                                    className="form-control" 
                                    id="BQuota" 
                                    placeholder="Enter B Quota" 
                                    value={payload.BQuota}
                                    onChange={onChangeHandler}
                                    onFocus={(e) => e.target.select()}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>
                        </div>

                        <div className="row mb-4">
                            <div className="col-md-6">
                                <label htmlFor="CQuota" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    C Quota (%) <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max="100"
                                    name="CQuota"
                                    className="form-control" 
                                    id="CQuota" 
                                    placeholder="Enter C Quota" 
                                    value={payload.CQuota}
                                    onChange={onChangeHandler}
                                    onFocus={(e) => e.target.select()}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="DQuota" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}>
                                    D Quota (%) <span style={{color: 'red'}}>*</span>
                                </label>
                                <input 
                                    required
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    max="100"
                                    name="DQuota"
                                    className="form-control" 
                                    id="DQuota" 
                                    placeholder="Enter D Quota" 
                                    value={payload.DQuota}
                                    onChange={onChangeHandler}
                                    onFocus={(e) => e.target.select()}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 12px',
                                        fontSize: '16px',
                                        border: '1px solid #d1d5db'
                                    }}
                                />
                            </div>
                        </div>

                        <div className="row mb-4">
                            <div className="col-md-6">
                                <label htmlFor="Remaining" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}
                                    data-tooltip-id="tooltip-rating-quota"
                                    data-tooltip-content="We will add a quota to this rating where the calculation is less than the total of all calibrated people"
                                >
                                    Remaining (+) <span style={{color: 'red'}}>*</span>
                                </label>
                                <Select
                                    allowClear
                                    size="large"
                                    style={{
                                        width: '100%'
                                    }}
                                    name="Remaining"
                                    options={ratingChoices}
                                    placeholder="Enter Remaining Quota"
                                    onChange={handleSelectRemaining}
                                    value={payload.Remaining}
                                    fontSize="16px"
                                />
                            </div>

                            <div className="col-md-6">
                                <label htmlFor="Excess" style={{ 
                                    fontWeight: '600', 
                                    color: '#374151', 
                                    fontSize: '14px',
                                    marginBottom: '8px',
                                    display: 'block'
                                }}
                                    data-tooltip-id="tooltip-rating-quota"
                                    data-tooltip-content="We will reduce the quota on this rating where the calculation is more than the total of all calibrated people"
                                >
                                    Excess (-) <span style={{color: 'red'}}>*</span>
                                </label>
                                <Select
                                    allowClear
                                    size="large"
                                    style={{
                                        width: '100%'
                                    }}
                                    name="Excess"
                                    options={ratingChoices}
                                    placeholder="Enter Excess Quota"
                                    onChange={handleSelectExcess}
                                    value={payload.Excess}
                                    fontSize="16px"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Total Quota Helper */}
                    <div style={{
                        padding: '16px 20px',
                        backgroundColor: getTotalQuota() === 100 ? '#d1fae5' : getTotalQuota() > 100 ? '#fee2e2' : '#fef3c7',
                        borderRadius: '8px',
                        border: `1px solid ${getTotalQuota() === 100 ? '#10b981' : getTotalQuota() > 100 ? '#ef4444' : '#f59e0b'}`,
                        marginBottom: '24px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <div>
                            <span style={{
                                fontWeight: '600',
                                fontSize: '14px',
                                color: getTotalQuota() === 100 ? '#065f46' : getTotalQuota() > 100 ? '#dc2626' : '#92400e'
                            }}>
                                Total Quota: {getTotalQuota().toFixed(2)}%
                            </span>
                        </div>
                        <div>
                            {getTotalQuota() === 100 ? (
                                <span style={{ color: '#065f46', fontSize: '14px', fontWeight: '500' }}>✓ Perfect! Total is 100%</span>
                            ) : getTotalQuota() > 100 ? (
                                <span style={{ color: '#dc2626', fontSize: '14px', fontWeight: '500' }}>⚠ Exceeds 100% by {(getTotalQuota() - 100).toFixed(2)}%</span>
                            ) : (
                                <span style={{ color: '#92400e', fontSize: '14px', fontWeight: '500' }}>⚠ Short by {(100 - getTotalQuota()).toFixed(2)}%</span>
                            )}
                        </div>
                    </div>

                    <div className="d-flex justify-content-end">
                        { isUpdate ? 
                            <ActionButtonGradient
                                type="submit"
                                variant="primary"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Changes"}
                            />
                            :
                            <ActionButtonGradient
                                type="submit"
                                variant="success"
                                disabled={isSaving}
                                children={isSaving ? "Saving..." : "Save Rating Quota"}
                            />
                        }
                    </div>
                </form>
            </div>
            <Tooltip
                id="tooltip-rating-quota"
                style={{ 
                    backgroundColor: "#efefef", 
                    color: "#222", 
                    width: "20rem"
                }}
            />
        </div>
        
    )
}

export default RatingQuotaForm